<script setup>
	import { computed } from 'vue'

	const props = defineProps({
		useFooter: [Boolean, Number], // [OPTIONAL] (use-footer) The footer only renders when this prop is included
		id: String, // [OPTIONAL] (id) This is required if you have more than one modal on a page
		size: String,
		headerClass: String,
		static : Boolean,
		footerJustifyEnd: {
			type: Boolean,
			default: false
		},
		instant: {
			type: Boolean,
			default: false
		}
	})

	const size = computed(() => {
		const sizeProp = props.size
		if(sizeProp == 'small') {
			return 'modal-sm'
		} else if(sizeProp == 'medium') {
			return ''
		} else if(sizeProp == 'x-large') {
			return 'modal-xl'
		} else if(sizeProp == 'fullscreen') {
			return 'modal-fullscreen'
		} else {
			return 'modal-lg'
		}
	})

</script>

<template>
	<div class="modal" :class="{ fade: ! instant }" :id="`${id ?? 'modal-large'}`" :data-bs-backdrop="static ? 'static' : 'true'" :data-bs-keyboard="static ? 'false' : 'true'">
				<div :class="`modal-dialog ${size} ${static ? 'modal-dialog-centered' : ''}`">

				<div class="modal-content">

						<div v-if="$slots.header" class="modal-header">

							<h5 class="modal-title" :class="headerClass">
								<slot name="header"></slot>
							</h5>

							<button v-if="! static" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div v-else class="d-flex justify-content-end p-3">
							<button v-if="! static" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>

							<!-- Body slot -->
							<div class="modal-body">
									<slot name="body"></slot>
							</div>

							<!-- Footer slot -->
							<div v-if="useFooter" class="modal-footer" :class="{ 'justify-content-end': footerJustifyEnd, 'justify-content-between': ! footerJustifyEnd }">
									<slot name="footer"></slot>
							</div>

					</div>

				</div>
	</div>
</template>

<style lang="scss">
	// Same as the modal footer but can be used inside the modal-body
	.modal-buttons {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
    background-color: #373c41;
    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
    border-bottom-right-radius: var(--bs-modal-inner-border-radius);
    border-bottom-left-radius: var(--bs-modal-inner-border-radius);
		width: calc(100% + 30px);
		margin-left: -15px;
		margin-bottom: -15px;
	}
</style>